/*
 * @Author: 小周
 * @Date: 2023-09-07 11:06:11
 * @LastEditTime: 2024-08-02 10:16:55
 * @LastEditors: MrZHLF
 * @Description: App分享
 */

import { checkDevice } from '@/utils/index'
import { shareLink, shareTitle, shareDesc, shareImg } from './weChatShare_conf'
import { ARTICLE_ID } from '@/constant/index'
/**
 *
 * @param { string } shareTitle 标题
 * @param { string } shareDesc 分享描述
 * @param { string } shareLink 分享回调地址
 * @param { string } shareImg  分享logo
 * @author 小周
 */
export function appShare(obj = {}) {
  var xPhone = checkDevice() //全局手机类型
  if ('IOS' == xPhone) {
    //ios大象新闻app环境
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.requestShareUrl
    ) {
      window.webkit.messageHandlers.requestShareUrl.postMessage({
        articleId: ARTICLE_ID,
        title: obj.shareTitle || shareTitle,
        summary: obj.shareDesc || shareDesc,
        shareUrl: obj.shareLink || shareLink,
        image: obj.shareImg || shareImg,
      })
    }
  } else {
    //Android大象新闻app环境
    if (window.Android && window.Android.tongYong) {
      window.Android.tongYong(
        'requestShareUrl',
        JSON.stringify({
          articleId: ARTICLE_ID,
          title: obj.shareTitle || shareTitle,
          summary: obj.shareDesc || shareDesc,
          shareUrl: obj.shareLink || shareLink,
          image: obj.shareImg || shareImg,
        })
      )
    }
    return true
  }
}
